import React, { useEffect, useRef } from 'react';
import styles from './FeatureInProgressModal.module.css';

const FeatureInProgressModal = ({ isOpen, onClose }) => {
  const okButtonRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen && okButtonRef.current) {
      okButtonRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      // Only close via OK button or Escape
    }
  };

  return (
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="fip-modal-title"
        aria-describedby="fip-modal-desc"
      >
        <div className={styles.content}>
          <h2 id="fip-modal-title" className={styles.title}>
            Coming Soon
          </h2>
          <p id="fip-modal-desc" className={styles.message}>
            This feature is currently in development and will be available soon.
          </p>
          <button
            ref={okButtonRef}
            type="button"
            className={styles.okButton}
            onClick={onClose}
            aria-label="Close modal"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureInProgressModal;

